
module dg.objects {
   
    angular.module('dg.objects').component('valueOnlyLayout', {
        bindings: {
            propertyId: '@',
            options: '<?'
        },
        require: {
            ObjectDisplayerController: '^objectDisplayer'
        },
        controller: DisplayLayoutController,
        templateUrl: '/digmo/src/objects/properties/layouts/value-only-layout.html'
    });
}